import { apiClient } from "@/lib/apiClient";
import {
  CreateChargeDto,
  UpdateChargeDto,
  FetchChargesOptions,
} from "@/types/models/charge";

// Charge CRUD Operations
export const getCharges = async (options: FetchChargesOptions = {}) => {
  const params: Record<string, string> = {};

  if (options.page) params.page = options.page.toString();
  if (options.page_size) params.page_size = options.page_size.toString();
  if (options.sort_by) params.sort_by = options.sort_by;
  if (options.sort_order) params.sort_order = options.sort_order;

  return await apiClient.getPaginated("/api/v1/admin/:storeId/charges", params);
};

export const getChargeById = async (id: string): Promise<any> => {
  return await apiClient.get(`/api/v1/admin/:storeId/charges/${id}`);
};

export const createCharge = async (data: CreateChargeDto): Promise<any> => {
  return await apiClient.post("/api/v1/admin/:storeId/charges", data);
};

export const updateCharge = async (
  id: string,
  data: UpdateChargeDto,
): Promise<any> => {
  return await apiClient.put(`/api/v1/admin/:storeId/charges/${id}`, data);
};

export const deleteCharge = async (id: string): Promise<any> => {
  return await apiClient.delete(`/api/v1/admin/:storeId/charges/${id}`);
};

// Search charges
export const searchCharges = async (
  query: string,
  options: FetchChargesOptions = {},
) => {
  const params: Record<string, string> = {
    search: query,
  };

  if (options.page) params.page = options.page.toString();
  if (options.page_size) params.page_size = options.page_size.toString();
  if (options.sort_by) params.sort_by = options.sort_by;
  if (options.sort_order) params.sort_order = options.sort_order;

  return await apiClient.getPaginated("/api/v1/admin/:storeId/charges", params);
};
